import React, { useEffect } from 'react'
import { HomeContainerStyled } from './styled'
import { Section, TaskBlock, Image } from '../../components'
import { dashboardController } from '../../apiService'
import { sealStatus } from '../../helpers/constants/sealStatus'
import { ICONS } from '../../themes'
import { ROLE_BUYER, ROLE_SUPPLIER } from 'store/role/constants'
import { pageHomeController, rolesObj } from '../../middleware'
import { find, map } from 'lodash'
import { useAuth } from '../../contexts/Auth.context'
import { localStorageService } from '../../helpers'
import { getState, store } from '../../store'
import {
  // filterSearchInput,
  // filterSearchOptions,
  // filterSearchInput1,
  // filterSearchOptions2,
  // filterSearchOptions3,
  // filterSearchOptions4,
  // filterSearchSourcingInput1,
  // filterSearchSourcingOptions2,
  // filterSearchSourcingOptions3,
  // filterSearchSourcingOptions4,
  // filterSourcingSupplierInput1,
  // filterSourcingSupplierOptions2,
  // filterSourcingSupplierOptions3,
  // filterSourcingSupplierOptions4,
  // filterSearchSourcingOptions5,
  // filterSourcingSupplierOptionsEventType,
  // filterDateFrom,
  // filterDateTo,
  // filterPage,
  // filterPageAllEvent,
  // filterStatusSourcingProjects,
  searchEventListSearch,
  searchEventListAllStatus,
  searchEventListAllEventType,
  searchEventListSealStatus,
  searchEventListAllAward,
  searchEventListAllUser,
} from '../../store/actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import clearFilter from '../RouteContainer/functions/clearFilter'
import { getWebRole } from '../../hooks/useAuthUtil'

export const SupportLink = () => {
  if (getWebRole() === ROLE_SUPPLIER) {
    return (
      <Section>
        <span style={{ color: '#4b4acb', fontWeight: 600 }}>
          For help and support,{' '}
        </span>{' '}
        <a
          // href="https://helpdesk.tspacesourcing.com"
          href="https://astrosystem.co/th/projects/projects-procurement/"
          target="new"
          style={{
            marginLeft: '10px',
            fontWeight: 600,
            color: '#4b4acb',
            textDecoration: 'underline',
          }}
        >
          click here
        </a>
      </Section>
    )
  }

  return null
}

class HomeContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      statusSupplierOpen: {},
      statusBuyerDashboard: [],
      isAdmin: false,
      isUser: false,
      isRisk: false,
      isPurchaser: false,
      isApprover: false,
      isTec: false,
    }
    this.renderSourcingTasks = this.renderSourcingTasks.bind(this)
    this.renderRoles = this.renderRoles.bind(this)
  }

  componentDidMount = () => {
    this._isMounted = true

    const { role, user } = this.props

    switch (role) {
      case ROLE_BUYER:
        this.getBuyerDashboard()
        break
      case ROLE_SUPPLIER:
        this.getSupplierDashboard()
        break
    }

    // if (this._isMounted) {
    this.setState({ role })
    this.renderUserRole(user)
    clearFilter()
    // }
  }

  renderUserRole(user) {
    let { isAdmin, isUser, isPurchaser, isRisk, isApprover, isTec } = this.state
    if (user) {
      if (!user.roles) {
        user.roles = [{ id: user.role }]
      }

      user.roles.map(e => {
        switch (e.id) {
          case 2:
            isAdmin = true
            break
          case 3:
            isAdmin = true
            break
          case 4:
            isUser = true
            break
          case 7:
            isRisk = true
            break
          case 8:
            isPurchaser = true
            break
          case 9:
            isApprover = true
            break
          case 10:
            isTec = true
            break
        }
      })
    }
    // console.log({ isAdmin, isUser, isRisk, isPurchaser, isApprover, isTec })
    this.setState({ isAdmin, isUser, isRisk, isPurchaser, isApprover, isTec })
  }

  renderSourcingTasks = (roleObj, statusBuyerDashboard) => {
    const rolesCheck = pageHomeController().asset()
    const getMultiRole = pageHomeController().getMultiRole()
    const tecRole = find(getMultiRole, data => {
      return data.id === rolesObj.tec
    })
    // console.log(rolesCheck, getMultiRole)
    const renderStatusDashboard = () => {
      const { id: buyerId } = getState().user
      const handlersClick = (name, id, amount) => {
        switch (name) {
          case 'Awaiting Selection':
            this.props.history.push('/sourcing-buyer', {
              award: 3,
              buyerId:
                this.state.isPurchaser || this.state.isAdmin ? buyerId : 0,
            })
            break
          case 'Awaiting Approve':
            this.props.history.push('/sourcing-buyer', {
              award: 4,
              amount,
            })
            break
          case sealStatus.awaitingunseal:
            this.props.history.push('/sourcing-buyer', {
              awaitingunseal: 2,
            })
            break
          default:
            this.props.history.push('/sourcing-buyer', {
              status: id,
              buyerId:
                this.state.isPurchaser || this.state.isAdmin ? buyerId : 0,
            })
            break
        }
      }
      return map(statusBuyerDashboard, (e, i) => {
        const { name, id, amount } = e
        return (
          <TaskBlock
            key={i}
            task={amount}
            onClick={() => handlersClick(name, id, amount)}
          >
            {name}
          </TaskBlock>
        )
      })
    }
    if (rolesCheck) {
      return (
        <React.Fragment>
          <Section className="dashboard">
            <Section className="task-group">
              {/* {tecRole ? (
                <Section className="heading">TEC</Section>
              ) : (
                <Section className="heading">RFQ</Section>
              )} */}
              <Section className="body">{renderStatusDashboard()}</Section>
            </Section>
          </Section>
        </React.Fragment>
      )
    }
  }

  getBuyerDashboard = async () => {
    try {
      const res = await dashboardController().getQtyStatus()
      if (res) {
        if (this._isMounted) {
          this.setState({ statusBuyerDashboard: res })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getSupplierDashboard = async () => {
    try {
      const res = await dashboardController().getSupplierQtyStatus()
      if (res) {
        if (res) {
          if (this._isMounted) {
            this.setState({ statusSupplierDashboard: res })
          }
        }
      }
    } catch (error) {
      throw error
    }
  }

  contactDetail = () => {
    return (
      <Section className="row">
        <Section className="col-6 flex-column">
          <div className="contact-wrapper">
            <p>
              For help, please contact our Procurement Service Center <br />{' '}
              Tel: +66 2 079 7333 <br /> Email: PSC@thaibev.com <br /> Operation
              date and time: Mon - Fri, 8:30 a.m. - 5 p.m. (Except Public
              Holidays)
            </p>
            <p>
              --------------------------------------------------------------------------------------------
            </p>
            <p>
              ติดต่อเรา <br /> ศูนย์บริการด้านการจัดซื้อ <br /> โทรศัพท์: +66 2
              079 7333 <br /> อีเมล: PSC@thaibev.com <br /> วันและเวลาทำการ:
              จันทร์ - ศุกร์ 8:30 - 17:00 น. ยกเว้นวันหยุดนักขัตฤกษ์
            </p>
          </div>
        </Section>
        <Section className="col-6 flex-column">
          <div className="contact-wrapper">
            <p>
              For help, regarding e-Auction, please contact the Auction Admin
              <br /> Tel: +66 63 082 1319 <br /> Email:
              Auctionadmin.pan@thaibev.com
              <br /> Operation date and time: Mon - Fri, 8:30 a.m. - 5 p.m.
              (Except Public Holidays)
            </p>
            <p>
              --------------------------------------------------------------------------------------------
            </p>
            <p>
              ติดต่อเรา (งานประมูล) <br /> เจ้าหน้าที่ดูแลงานประมูล <br />{' '}
              โทรศัพท์: +66 63 082 1319 <br /> อีเมล:
              Auctionadmin.pan@thaibev.com <br />
              วันและเวลาทำการ: จันทร์ - ศุกร์ 8:30 - 17:00 น.
              ยกเว้นวันหยุดนักขัตฤกษ์
            </p>
          </div>
        </Section>
      </Section>
    )
  }

  renderRoles = () => {
    const { statusBuyerDashboard, statusSupplierDashboard } = this.state
    const { role } = this.props
    if (role === ROLE_BUYER) {
      return (
        <React.Fragment>
          <HomeContainerStyled className="home-page">
            <Section className="page-topbar">
              <Section className="page-header">
                <Section className="page-icon">
                  <Image
                    id="page_icon_buyer_management"
                    src={ICONS['icon-home-white.svg']}
                    alt="page icon"
                  />
                </Section>
                <Section className="title-and-breadcrumb">
                  <Section id="page_title_home" className="title">
                    My Sourcing Tasks
                  </Section>
                </Section>
              </Section>
            </Section>
            {/* renderIsPurchaser */}
            {this.renderSourcingTasks(this.state, statusBuyerDashboard)}
          </HomeContainerStyled>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <HomeContainerStyled className="home-page">
            <Section className="page-topbar">
              <Section className="page-header">
                <Section className="page-icon">
                  <Image
                    id="page_icon_buyer_management"
                    src={ICONS['icon-home-white.svg']}
                    alt="page icon"
                  />
                </Section>
                <Section className="title-and-breadcrumb">
                  <Section id="page_title_home" className="title">
                    My Sourcing Tasks
                  </Section>
                </Section>
              </Section>
            </Section>
            <Section className="dashboard">
              <Section className="task-group">
                {/* <Section className="heading">RFQ</Section> */}
                <Section className="body">
                  <TaskBlock
                    task={
                      statusSupplierDashboard
                        ? statusSupplierDashboard.awaiting_open
                        : null
                    }
                    onClick={() => {
                      this.props.history.push('/sourcing-supplier', {
                        statusId: 2,
                      })
                    }}
                  >
                    Awaiting Open
                  </TaskBlock>
                  <TaskBlock
                    task={
                      statusSupplierDashboard
                        ? statusSupplierDashboard.open
                        : null
                    }
                    onClick={() => {
                      this.props.history.push('/sourcing-supplier', {
                        statusId: 3,
                      })
                    }}
                  >
                    Open
                  </TaskBlock>
                </Section>
              </Section>
              <SupportLink />
            </Section>
          </HomeContainerStyled>
        </React.Fragment>
      )
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    return this.renderRoles()
  }
}

const mapStateToProps = state => {
  // console.log('home', state)
  return {
    user: state.user,
    role: state.role,
  }
}

export default connect(mapStateToProps)(withRouter(HomeContainer))
